/*
* wehsoft Theme
*
* Use this file to add custom Javascript to wehsoft.  Keeping your custom
* Javascript in this fill will make it easier to update wehsoft. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Toggle collection filters drawer on click
  document.addEventListener('click', function(event) {
    var toggleButton = event.target.closest('[data-toggle-filters]');
    if (toggleButton) {
      var filters = document.querySelector('[data-collection-filters]');
      if (filters) {
        filters.classList.add('collection__filters--visible');
        if (window.innerWidth < 768) {
          var scrollableElement = document.querySelector('[data-filters-list]');
          document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableElement}));
        }
        event.preventDefault();
        event.stopPropagation();
      }
    }

    // Close collection filters drawer on clicking close elements
    var closeButton = event.target.closest('[data-close-filters]');
    if (closeButton) {
      var filters = document.querySelector('[data-collection-filters]');
      if (filters) {
        filters.classList.remove('collection__filters--visible');
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
        event.preventDefault();
        event.stopPropagation();
      }
    }
    // Handle sizes carousel click events
    var prevBtn = event.target.closest('[data-sizes-prev]');
    var nextBtn = event.target.closest('[data-sizes-next]');
    if (prevBtn || nextBtn) {
      var btn = prevBtn || nextBtn;
      var wrapper = btn.closest('.product-grid-item__sizes-carousel-wrapper');
      if (wrapper) {
        var carousel = wrapper.querySelector('[data-sizes-carousel]');
        var list = wrapper.querySelector('.product-grid-item__sizes-list');
        if (carousel && list) {
          var itemWidth = 41; // 35px width + 6px gap
          var visibleWidth = 158; // viewport width
          var totalWidth = list.scrollWidth;
          var currentTransform = list.style.transform || 'translateX(0px)';
          var currentX = parseInt(currentTransform.replace(/[^\d-]/g, '')) || 0;
          
          var maxShift = -(totalWidth - visibleWidth);
          if (maxShift > 0) maxShift = 0;
          
          var shift = prevBtn ? (currentX + itemWidth) : (currentX - itemWidth);
          if (shift > 0) shift = 0;
          if (shift < maxShift) shift = maxShift;
          
          list.style.transform = 'translateX(' + shift + 'px)';
          
          var prev = wrapper.querySelector('[data-sizes-prev]');
          var next = wrapper.querySelector('[data-sizes-next]');
          if (prev) prev.style.opacity = (shift === 0) ? '0.3' : '1';
          if (next) next.style.opacity = (shift <= maxShift) ? '0.3' : '1';
        }
      }
      event.preventDefault();
      event.stopPropagation();
    }

    // Fallback: Close quick view drawer programmatically when close button is clicked
    var quickClose = event.target.closest('[data-popup-close]');
    if (quickClose && quickClose.classList.contains('popup-quick-view__close')) {
      var pswp = quickClose.closest('.pswp');
      if (pswp) {
        var realClose = pswp.querySelector('.pswp__button--close, .pswp__custom-close');
        if (realClose) {
          realClose.click();
          event.preventDefault();
          event.stopPropagation();
        }
      }
    }
  });


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
